
import Button from '@/components/UntitledUI/Button.vue'
import {Mention} from '@tiptap/extension-mention'
import suggestion from '@/components/common/Editor/Mention/suggestion'
import {Placeholder} from '@tiptap/extension-placeholder'
import TipTapEditor from '@/components/common/TipTapEditor.vue'
import {mergeAttributes} from '@tiptap/core'

export default {
    name: 'ChatMessageInput',
    components: { Button, TipTapEditor },
    inject: ['user'],
    props: {
        chatRoom: {
            type: Object,
            required: true
        },
        members: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            sendMessageForm: new this.$vForm({
                message: ''
            }),
            extensions: []
        }
    },
    computed: {
        canSend () {
            return this.sendMessageForm.message.replaceAll(/<[^>]*>/g, '').trim().length
        },
        mentionMembers () {
            return this.members.filter(m => m.user_id !== this.user?.id)
        }
    },
    created () {
        const UserMention = Mention.extend({
            renderHTML ({ node, HTMLAttributes }) {
                return [
                    'span',
                    mergeAttributes({ 'data-type': 'mention' }, HTMLAttributes),
                    `@${node.attrs.name}`
                ]
            },
            addAttributes () {
                return {
                    ...this.parent(),
                    member: {
                        default: null,
                        parseHTML: (element) => {
                            return {
                                member: element.getAttribute('data-member')
                            }
                        },
                        renderHTML: (attributes) => {
                            if (!attributes.member) {
                                return {}
                            }
                            return {
                                'data-member': attributes.member
                            }
                        }
                    },
                    name: {
                        default: null
                    }
                }
            }
        })
        this.extensions = [
            Placeholder.configure({
                placeholder: this.$t('يمكنك الرد أو اضافة مستخدمين اخرين @')
            }),
            UserMention.configure({
                suggestion: {
                    ...suggestion,
                    items: ({ query }) => {
                        return this.mentionMembers.filter(mem =>
                            mem.name.toLowerCase().startsWith(query.toLowerCase()) ||
                            mem.email.toLowerCase().startsWith(query.toLowerCase())
                        )
                    }
                }
            })
        ]
    },
    methods: {
        send () {
            if (!this.canSend) {
                this.sendMessageForm.errors.set('message', this.$t('نص الرسالة مطلوب.'))
                return
            }
            let container = document.createElement('div')
            container.innerHTML = this.sendMessageForm.message
            container = container.firstElementChild.innerHTML.trim().replace(/^(?:<br>\s*)+|(?:\s*<br>)+$/ig, '')
            const message = document.createElement('p')
            message.innerHTML = container
            this.sendMessageForm.message = message.outerHTML
            this.sendMessageForm.post(`/v1/chat-rooms/${this.chatRoom.id}/chat-room-messages`)
                .then((res) => {
                    const message = res.data.data ?? res.data
                    this.$emit('message-sent', message)
                    this.sendMessageForm.message = ''
                })
        }
    }
}
